import { render, staticRenderFns } from "./FeeTypeValuesList.vue?vue&type=template&id=6becf8ca&scoped=true&lang=pug&"
import script from "./FeeTypeValuesList.vue?vue&type=script&lang=js&"
export * from "./FeeTypeValuesList.vue?vue&type=script&lang=js&"
import style0 from "./FeeTypeValuesList.vue?vue&type=style&index=0&id=6becf8ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6becf8ca",
  null
  
)

/* custom blocks */
import block0 from "./FeeTypeValuesList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports